import { styled } from "@mui/material/styles";
import {
    Checkbox,
    Grid,
    GridProps,
    InternalStandardProps,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
} from "@mui/material";

const StyledRoot = styled("div")({
    width: "100%",
});

const StyledListItem = styled(ListItem)(({ theme }) => ({
    color: `${theme.palette.grey[800]}`,
}));

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
    color: `${theme.palette.grey[700]}`,
    "&.Mui-checked": {
        color: `${theme.palette.primary.main} !important`,
    },
}));

const StyledListItemText = styled(ListItemText)(({ theme }) => ({
    maxWidth: "80%",
    minWidth: "80%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    [theme.breakpoints.down("md")]: {
        maxWidth: "70%",
        minWidth: "70%",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    [theme.breakpoints.down("sm")]: {
        maxWidth: "65%",
        minWidth: "65%",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
}));

export interface AppCheckboxListProps extends InternalStandardProps<GridProps> {
    checkboxList: any[];
    onToggleItemSelect: (item: string) => void;
    selectedMembers: any[];
}

export const AppCheckboxList = (props: AppCheckboxListProps) => {
    const { className, checkboxList, selectedMembers, onToggleItemSelect } =
        props;

    return (
        <StyledRoot className={className}>
            <Grid item xs={12}>
                <List
                    sx={{
                        width: "100%",
                    }}
                >
                    {checkboxList &&
                        checkboxList.length > 0 &&
                        checkboxList.map((value) => {
                            const labelId = `checkbox-list-secondary-label-${value.member_id}`;
                            return (
                                <StyledListItem
                                    key={value.member_id}
                                    secondaryAction={
                                        <StyledCheckbox
                                            edge="end"
                                            onChange={() =>
                                                onToggleItemSelect(value)
                                            }
                                            checked={
                                                selectedMembers.findIndex(
                                                    (x) =>
                                                        x.member_id ===
                                                        value.member_id,
                                                ) !== -1
                                            }
                                            inputProps={{
                                                "aria-labelledby": labelId,
                                            }}
                                        />
                                    }
                                    disablePadding
                                >
                                    <ListItemButton>
                                        <StyledListItemText
                                            id={labelId}
                                            primary={`${value.first_name} ${value.last_name}`}
                                        />
                                        <ListItemText
                                            id={`${labelId}_${value.first_name}`}
                                            primary={`${value.member_id}`}
                                        />
                                    </ListItemButton>
                                </StyledListItem>
                            );
                        })}
                </List>
            </Grid>
        </StyledRoot>
    );
};
